import React from 'react';
import MessageListItem from '../MessageListItem/MessageListItem';
import './RecentChat.css';

const RecentChats = () => {
  return (
    <section className="section pd">
      <h4>Recent Chats</h4>
      <MessageListItem />
      <MessageListItem badge username="#simplytolz" />
      <MessageListItem badge username="#simplytolz" />
      <MessageListItem />
    </section>
  );
};

export default RecentChats;
